const plazaAbbreviations = [
    {
        plaza_name: "Woodbury Toll NYS Thruway",
        abbreviation: "15",
    },
    {
        plaza_name: "Harriman NYS Thruway",
        abbreviation: "16H",
    },
    {
        plaza_name: "Harriman NYS Thruway",
        abbreviation: "16W",
    },
    {
        plaza_name: "Newburgh NYS Thruway",
        abbreviation: "17",
    },
    {
        plaza_name: "New Paltz NYS Thruway",
        abbreviation: "18",
    },
    {
        plaza_name: "Kingston NYS Thruway",
        abbreviation: "19",
    },
    {
        plaza_name: "Saugerties NYS Thruway",
        abbreviation: "20E",
    },
    {
        plaza_name: "Saugerties NYS Thruway",
        abbreviation: "20W",
    },
    {
        plaza_name: "Catskill NYS Thruway",
        abbreviation: "21",
    },
    {
        plaza_name: "Coxsackie NYS Thruway",
        abbreviation: "21B",
    },
    {
        plaza_name: "Selkirk NYS Thruway",
        abbreviation: "22",
    },
    {
        plaza_name: "Albany (I-787) NYS Thruway",
        abbreviation: "23",
    },
    {
        plaza_name: "Albany (I-87) NYS Thruway",
        abbreviation: "24",
    },
    {
        plaza_name: "Schenectady (I-890) NYS Thruway",
        abbreviation: "25",
    },
    {
        plaza_name: "Schenectady (I-88) NYS Thruway",
        abbreviation: "25A",
    },
    {
        plaza_name: "Schenectady (I-890 & Rt 5s) NYS Thruway",
        abbreviation: "26",
    },
    {
        plaza_name: "Amsterdam NYS Thruway",
        abbreviation: "27",
    },
    {
        plaza_name: "Fulltonville NYS Thruway",
        abbreviation: "28",
    },
    {
        plaza_name: "Canajoharie NYS Thruway",
        abbreviation: "29",
    },
    {
        plaza_name: "Little Falls NYS Thruway",
        abbreviation: "29A",
    },
    {
        plaza_name: "Herkimer NYS Thruway",
        abbreviation: "30",
    },
    {
        plaza_name: "Utica NYS Thruway",
        abbreviation: "31",
    },
    {
        plaza_name: "Westmoreland NYS Thruway",
        abbreviation: "32",
    },
    {
        plaza_name: "Verona NYS Thruway",
        abbreviation: "33",
    },
    {
        plaza_name: "Canastota NYS Thruway",
        abbreviation: "34",
    },
    {
        plaza_name: "Syracuse (I-481) NYS Thruway",
        abbreviation: "34A",
    },
    {
        plaza_name: "Syracuse (Rt 298) NYS Thruway",
        abbreviation: "35",
    },
    {
        plaza_name: "Syracuse (I-81) NYS Thruway",
        abbreviation: "36",
    },
    {
        plaza_name: "Syracuse (Electronics Pkwy) NYS Thruway",
        abbreviation: "37",
    },
    {
        plaza_name: "Syracuse (Liverpool) NYS Thruway",
        abbreviation: "38",
    },
    {
        plaza_name: "Syracuse (I-690) NYS Thruway",
        abbreviation: "39",
    },
    {
        plaza_name: "Weedsport NYS Thruway",
        abbreviation: "40",
    },
    {
        plaza_name: "Waterloo NYS Thruway",
        abbreviation: "41",
    },
    {
        plaza_name: "Geneva NYS Thruway",
        abbreviation: "42",
    },
    {
        plaza_name: "Manchester NYS Thruway",
        abbreviation: "43",
    },
    {
        plaza_name: "Canandaigua NYS Thruway",
        abbreviation: "44",
    },
    {
        plaza_name: "Rochester (I-490) NYS Thruway",
        abbreviation: "45",
    },
    {
        plaza_name: "Rochester (I-390) NYS Thruway",
        abbreviation: "46",
    },
    {
        plaza_name: "Rochester (I-490) NYS Thruway",
        abbreviation: "47",
    },
    {
        plaza_name: "Batavia NYS Thruway",
        abbreviation: "48",
    },
    {
        plaza_name: "Pembroke Rte NYS Thruway",
        abbreviation: "48A",
    },
    {
        plaza_name: "Depew NYS Thruway",
        abbreviation: "49",
    },
    {
        plaza_name: "Williamsville Toll NYS Thruway",
        abbreviation: "50",
    },
    {
        plaza_name: "Lackawanna Toll NYS Thruway",
        abbreviation: "55",
    },
    {
        plaza_name: "Blasdell NYS Thruway",
        abbreviation: "56",
    },
    {
        plaza_name: "Hamburg NYS Thruway",
        abbreviation: "57",
    },
    {
        plaza_name: "Eden NYS Thruway",
        abbreviation: "57A",
    },
    {
        plaza_name: "Silver Creek NYS Thruway",
        abbreviation: "58",
    },
    {
        plaza_name: "Dunkirk NYS Thruway",
        abbreviation: "59",
    },
    {
        plaza_name: "Westfield NYS Thruway",
        abbreviation: "60",
    },
    {
        plaza_name: "Ripley Toll NYS Thruway",
        abbreviation: "61",
    },
    {
        plaza_name: "Rip Van Winkle Br NYS Bridge Authority",
        abbreviation: "RVW",
    },
    {
        plaza_name: "Kingston-Rhinecliff Br NYS Bridge Authority",
        abbreviation: "KRB",
    },
    {
        plaza_name: "Mid-Hudson Br NYS Bridge Authority",
        abbreviation: "MHB",
    },
    {
        plaza_name: "Newburgh-Beacon Br NYS Bridge Authority",
        abbreviation: "NBB",
    },
    {
        plaza_name: "Bear Mountain Br NYS Bridge Authority",
        abbreviation: "BMB",
    },
    {
        plaza_name: "Albany (I-90W) NYS Thruway",
        abbreviation: "B1",
    },
    {
        plaza_name: "Taconic Parkway NYS Thruway",
        abbreviation: "B2",
    },
    {
        plaza_name: "Canaan Toll NYS Thruway",
        abbreviation: "B3",
    },
    {
        plaza_name: "Bayonne Bridge Port Authority NY/NJ",
        abbreviation: "BB",
    },
    {
        plaza_name: "Hugh L. Carey Tunnel MTA Bridges & Tunnels",
        abbreviation: "HCT",
    },
    {
        plaza_name: "Bronx Whitestone Br MTA Bridges & Tunnels",
        abbreviation: "BWB",
    },
    {
        plaza_name: "Cross Bay Br MTA Bridges & Tunnels",
        abbreviation: "CB",
    },
    {
        plaza_name: "Goethals Br Port Authority NY/NJ",
        abbreviation: "GB",
    },
    {
        plaza_name: "North Grand Island Br NYS Thruway",
        abbreviation: "GIN",
    },
    {
        plaza_name: "South Grand Island Br NYS Thruway",
        abbreviation: "GIS",
    },
    {
        plaza_name: "Geo Washington Br – Lower Level Port Authority NY/NJ",
        abbreviation: "GWL",
    },
    {
        plaza_name: "Geo Washington Br – Palisades Port Authority NY/NJ",
        abbreviation: "GWP",
    },
    {
        plaza_name: "Geo Washington Br – Upper Level Port Authority NY/NJ",
        abbreviation: "GWU",
    },
    {
        plaza_name: "Harriman Toll NYS Thruway",
        abbreviation: "HA",
    },
    {
        plaza_name: "Henry Hudson Br MTA Bridges & Tunnels",
        abbreviation: "HHB",
    },
    {
        plaza_name: "Holland Tunnel Port Authority NY/NJ",
        abbreviation: "HT",
    },
    {
        plaza_name: "Lincoln Tunnel Port Authority NY/NJ",
        abbreviation: "LT",
    },
    {
        plaza_name: "Marine Pkwy Br MTA Bridges & Tunnels",
        abbreviation: "MPB",
    },
    {
        plaza_name: "New Rochelle Toll NYS Thruway",
        abbreviation: "NR",
    },
    {
        plaza_name: "Outerbridge Crossing Port Authority NY/NJ",
        abbreviation: "OBX",
    },
    {
        plaza_name: "Peace Br Buffalo and Fort Erie Public Bridge Authority",
        abbreviation: "PB4",
    },
    {
        plaza_name: "Thousand Islands Br - USA Thousand Islands Bridge Authority",
        abbreviation: "TIA",
    },
    {
        plaza_name: "Thousand Islands Br - Canada Thousand Islands Bridge Authority",
        abbreviation: "TIC",
    },
    {
        plaza_name: "Queens Midtown Tunnel MTA Bridges & Tunnels",
        abbreviation: "QMT",
    },
    {
        plaza_name: "Robert F. Kennedy Br – Bronx MTA Bridges & Tunnels",
        abbreviation: "RFB",
    },
    {
        plaza_name: "Robert F. Kennedy Br – Manhattan MTA Bridges & Tunnels",
        abbreviation: "RFM",
    },
    {
        plaza_name: "Spring Valley Toll NYS Thruway",
        abbreviation: "SV",
    },
    {
        plaza_name: "Throgs Neck Br MTA Bridges & Tunnels",
        abbreviation: "TNB",
    },
    {
        plaza_name: "Gov. Mario M. Cuomo Br NYS Thruway",
        abbreviation: "MCB",
    },
    {
        plaza_name: "Verrazzano Narrows Br MTA Bridges & Tunnels",
        abbreviation: "VNB",
    },
    {
        plaza_name: "Yonkers Toll NYS Thruway",
        abbreviation: "YK",
    },
    {
        plaza_name: "Entered Congestion Relief Zone",
        abbreviation: "CRZ",
    },
    {
        plaza_name: "CRZ Crossing Credit OneWay",
        abbreviation: "CX1",
    },
    {
        plaza_name: "CRZ Crossing Credit OneWay",
        abbreviation: "CX2",
    },
    {
        plaza_name: "CRZ Crossing Credit",
        abbreviation: "CXC",
    },
];

export default plazaAbbreviations;
